import { useState } from 'react';
import { shortId } from '../lib/format';

interface CopyableIdProps {
  /** 完整 ID（tooltip + 複製內容） */
  value: string;
  /** 顯示字串;預設用 shortId 截斷 */
  display?: string;
  /** 額外 class（例如 text-tertiary 降階） */
  className?: string;
}

/**
 * 可複製的 mono ID chip：截斷顯示 + hover 顯示複製鍵。
 * 對應 shared.css 的 .adm-copy-mono / .adm-copy-btn。
 * 解決 audit「截斷 ID 無 tooltip/複製」痛點。
 */
export function CopyableId({ value, display, className }: CopyableIdProps) {
  const [copied, setCopied] = useState(false);

  async function copy(e: React.MouseEvent) {
    // 避免觸發外層 row 的 onClick(開詳情)
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      // 剪貼簿不可用時靜默;仍保留 tooltip 可手動選取
    }
  }

  return (
    <span className={`adm-copy-mono${className ? ` ${className}` : ''}`} title={value}>
      <span>{display ?? shortId(value)}</span>
      <button
        type="button"
        className="adm-copy-btn"
        onClick={copy}
        aria-label={copied ? '已複製' : '複製完整 ID'}
      >
        {copied ? '✓' : '⧉'}
      </button>
    </span>
  );
}
